import { graphql } from "./generated/gql";

export const CandidatesQuery = graphql(`
  query Candidates($termId: ID!) {
    candidates(termId: $termId) {
      nodes {
        candidateId
        termId
        sponsorEmployeeId
        sponsorEmployee {
          sponsorEmployeeId
          name
          email
        }
        uniqueToken
        status
        isKeyCandidate
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`);

export const BulkCreateCandidatesMutation = graphql(`
  mutation BulkCreateCandidates($input: BulkCreateCandidatesInput!) {
    bulkCreateCandidates(input: $input) {
      results {
        email
        matched
        candidate {
          candidateId
          termId
          sponsorEmployeeId
          sponsorEmployee {
            sponsorEmployeeId
            name
            email
          }
          status
          isKeyCandidate
          createdAt
          updatedAt
        }
      }
      createdCount
      unmatchedEmails
    }
  }
`);

export const DeleteCandidateMutation = graphql(`
  mutation DeleteCandidate($candidateId: ID!) {
    deleteCandidate(candidateId: $candidateId)
  }
`);

export const SendInvitationMutation = graphql(`
  mutation SendInvitation($candidateId: ID!) {
    sendInvitation(candidateId: $candidateId) {
      success
      candidateId
      errorMessage
    }
  }
`);

export const BulkSendInvitationMutation = graphql(`
  mutation BulkSendInvitation($termId: ID!) {
    bulkSendInvitation(termId: $termId) {
      total
      successCount
      failureCount
      results {
        candidateId
        email
        success
        errorMessage
      }
    }
  }
`);

export const UpdateCandidateMutation = graphql(`
  mutation UpdateCandidate($input: UpdateCandidateInput!) {
    updateCandidate(input: $input) {
      candidateId
      isKeyCandidate
    }
  }
`);
